import {
  Box,
  Center,
  type UseRadioProps,
  useCheckbox,
  useFormControlContext,
  useRadio,
} from "@chakra-ui/react"
import { FormattedMessage } from "react-intl"

import { P2B } from "@/components/Typographies"

interface Props extends UseRadioProps {
  labelTranslationId: string
}
export const RadioButton: React.FC<Props> = props => {
  const { labelTranslationId: label, ...radioProps } = props
  const { getInputProps } = useRadio(radioProps)
  const { getCheckboxProps } = useCheckbox(radioProps)

  const formControlContext = useFormControlContext() as
    | ReturnType<typeof useFormControlContext>
    | undefined // undefined when used outside of a form control

  const isInvalid = formControlContext?.isInvalid

  const input = getInputProps()
  const checkbox = getCheckboxProps()

  return (
    <Box as="label" flexGrow="1" width="100%">
      <input {...input} />
      <Center
        {...checkbox}
        cursor="pointer"
        borderWidth="1px"
        borderColor={isInvalid ? "danger" : "lineStrong"}
        backgroundColor="surface"
        color={isInvalid ? "danger" : "textMuted"}
        _checked={{
          color: "textInverse",
          backgroundColor: "surfaceInverse",
          borderColor: "surfaceInverse",
        }}
        textAlign="center"
        p={2}
        h="100%"
      >
        <P2B>
          <FormattedMessage id={label} />
        </P2B>
      </Center>
    </Box>
  )
}
